import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import AnimatedModal from "../AnimatedModal";
import { AppButton } from "../Generic/AppButton";
import AnimatedClockVector from "./components/AnimatedClockVector/AnimatedClockVector";

export interface PromptClockVerifyLocationModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onClickAllowAccess: () => void;
  onClickDontWantToClock: () => void;
}

const PromptClockVerifyLocationModal = (props: PromptClockVerifyLocationModalProps) => {
  const message = (
    <>
      <p>{translate(STRINGS.TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT)}</p>
      <p>{translate(STRINGS.YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION)}</p>
    </>
  );

  const actions = (
    <>
      <AppButton variant="filled" color="primary" onClick={props.onClickAllowAccess}>
        {translate(STRINGS.ALLOW_ACCESS_TO_MY_LOCATION)}
      </AppButton>

      <AppButton variant="link" color="black" onClick={props.onClickDontWantToClock}>
        {translate(STRINGS.I_DONT_WANT_TO_CLOCK)}
      </AppButton>
    </>
  );

  return (
    <AnimatedModal
      headline={translate(STRINGS.VERIFY_YOUR_LOCATION)}
      message={message}
      animation={<AnimatedClockVector />}
      animationOffset={100}
      actions={actions}
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    />
  );
};

export default PromptClockVerifyLocationModal;
